import React, { useState, useEffect } from "react";
import { Button } from 'flowbite-react';
import { GrUpgrade } from "react-icons/gr";
import { supabase } from '../../supabaseClient';
import { useAuth } from '../../context/UserContext';
import RightPanel from '../RightPanel';
import SidebarPanel from '../SidebarPanel'; 
import { Profileinfo } from "../Layout/Profileinfo";
import {Footer} from "../Layout/Footer";
import axios from "axios";
import Parser from 'html-react-parser';

const TrueFalse = () => {
  const { user, limit, setLimit } = useAuth() 

  const [QuestionType] = useState("true or false")

  const [ContentText, setContentText] = useState(
    `Steve Jobs, the iconic co-founder of Apple Inc., transformed the technology industry with his vision and innovation. Known for his relentless pursuit of excellence, Jobs introduced groundbreaking products like the Macintosh, iPod, iPhone, and iPad, redefining how people interact with technology. His focus on simplicity and user-friendly design made complex technology accessible to everyone, setting new industry standards.

Jobs’ approach emphasized the seamless integration of hardware and software, creating an ecosystem that revolutionized consumer electronics. His influence extended beyond Apple with the founding of Pixar Animation Studios, which pioneered computer-animated films, including Toy Story. Pixar’s success and subsequent acquisition by Disney made Jobs its largest individual shareholder, broadening his impact to entertainment.

Despite professional setbacks, including his ousting from Apple in 1985, Jobs returned in 1997 to lead the company to unprecedented success. Under his leadership, Apple introduced iconic products and became one of the world’s most valuable companies.

Renowned for his captivating keynote presentations, Jobs had a unique ability to inspire and connect with audiences. His passion for innovation, design, and pushing boundaries established him as a visionary entrepreneur. Steve Jobs’ enduring legacy lies in his ability to foresee the future of technology and his profound impact on multiple industries.`
  )

  const handleChangeContentText = (event) => {
    setContentText(event.target.value)
  }

  const [QuestionCount, setQuestionCount] = useState(1)

  const handleChangeQuestionCount = (event) => {
    setQuestionCount(event.target.value)
  }

  const [Difficulty, setDifficulty] = useState("easy")

  const handleChangeDifficulty = (event) => {
    setDifficulty(event.target.value)
  }

  const [OutputData, setOutputData] = useState('')

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (user) {

      const getLimit = async () => {
        const { error, data } = await supabase
          .from("tracking") //the table you want to work with
          .select("id, user_id, usage_limit, usage") //columns to select from the database
          .eq("user_id", user?.id) //comparison function to return only data with the user id matching the current logged in user
          .order("id", { ascending: false }); // sort the data so the last item comes on top;
      
        if (error) throw error; //check if there was an error fetching the data and move the execution to the catch block
        if(data.length > 0) {
          setLimit((data[0].usage_limit - data[0].usage))
        }
        // console.log(data)
      };

      getLimit();

    }
  });

  const getLimit = async () => {
    const { error, data } = await supabase
      .from("tracking") //the table you want to work with
      .select("id, user_id, usage_limit, usage") //columns to select from the database
      .eq("user_id", user?.id) //comparison function to return only data with the user id matching the current logged in user
      .order("id", { ascending: false }); // sort the data so the last item comes on top;

    if (error) throw error; //check if there was an error fetching the data and move the execution to the catch block
    // console.log(data)
    return data
  };

  const updateLimit = async (data) => {
    return await supabase.from("tracking").update({ usage: data[0].usage + 1 }).eq("user_id", user?.id)
    .eq("id", data[0].id); //matching id of row to update;
  };

  const insertLimit = async () => {
    return await supabase.from("tracking").insert({ user_id: user?.id, usage: 1, email: user?.email });
  };

  const handleSubmit = (event) => {
    setLoading(true)
    event.preventDefault()
    // console.log('QuestionType', QuestionType)
    // console.log('ContentText', ContentText)
    // console.log('QuestionCount', QuestionCount)
    // console.log('Difficulty', Difficulty)

    const payload = {
      'QuestionType': QuestionType,
      'ContentText': ContentText,
      'QuestionCount': QuestionCount,
      'Difficulty': Difficulty,
    }

    axios.post(process.env.REACT_APP_SERVER_URL + '/api/true-false', payload).then((response) => {
      // console.log(response)
      if (response.status === 200) {
        // console.log(response.data.filename)
        localStorage.setItem('filename_pdf', response.data.filename)
        setOutputData(response.data.html)
        getLimit().then( data => {
          if(data.length > 0) {
            updateLimit(data).then(res => {
              // console.log(res.status === 204)
              setLimit((limit - 1))
            })
          } else {
            insertLimit().then(res => {
              // console.log(res.status === 201)
              setLimit((limit - 1))
            })
          }
        })
        setLoading(false)
      }
    })

  }

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <SidebarPanel className="w-64 fixed top-0 left-0 h-full bg-primary shadow-lg" /> 
      <div className="flex-1 ml-64 overflow-y-auto p-6 bg-gray-50">  
        <header className="flex justify-end gap-10 items-center mb-6">
          <h4>Free Runs Remaining: <span>{limit}</span> </h4>
          <Button className='w-half bg-secondary text-black rounded-md hover:bg-primary hover:text-white  transition duration-300 icon_buttons'><GrUpgrade />Upgrade </Button>
          {user && (
            <Profileinfo/>
          )}
        </header>

        {/* Main Content */}
        <main className="main_wrapper">

          <h1 className="text-center mb-5 font-bold">True or False</h1>
          <div className="grid grid-cols-2">
            <div className="max-w-4xl   p-6 bg-gray-100 shadow-lg rounded-md">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

                <input type="hidden" value={QuestionType} />

                <div className="col-span-2">
                  <label htmlFor="questionText" className="block text-sm font-medium text-gray-700 mb-2">Text</label>
                  <textarea value={ContentText} onChange={handleChangeContentText} id="questionText" rows="4" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"></textarea>
                </div>

                <div>
                  <label htmlFor="questionCount" className="block text-sm font-medium text-gray-700 mb-2">Question Count</label>
                  <select value={QuestionCount} onChange={handleChangeQuestionCount} id="questionCount" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="difficulty" className="block text-sm font-medium text-gray-700 mb-2">Difficulty Level</label>
                  <select value={Difficulty} onChange={handleChangeDifficulty} id="difficulty" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-primary focus:border-primary">
                    <option value="easy">Easy</option>
                    <option value="medium">Medium</option>
                    <option value="hard">Hard</option>
                  </select>
                </div>
              </div>

              <div className="mt-6">
                <button onClick={(limit === 0) ? void(0) : handleSubmit} className="w-full p-3 bg-primary text-white rounded-md hover:bg-secondary hover:text-black transition duration-300" disabled={(limit === 0 || loading) ? 'disabled' : ''}>
                {loading ? (
                  <>
                   <svg aria-hidden="true" role="status" class="inline w-5 h-5 me-3 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"  fill="#0da9cc"/>
                  </svg>
                  <span className="pl-3">Loading...</span>
                  </>
                ) : 'Submit'}
                </button>
              </div>
            </div>
            <RightPanel showOutput={{'html': Parser(OutputData), 'type': 'True-False'}}/>
          </div> 
          <Footer position="absolute" />
        </main>
      </div>
    </div>
  );
};

export default TrueFalse;
